export const siteContent = {
  company: {
    legalName: "CV. Samudra Kiat Jaya",
    brandName: "Samudra Charcoal",
    established: "2016",
    tagline: "Premium Coconut Shell Charcoal Briquettes",
  },
  contact: {
    email: "samudracharcoal@gmail.com",
    whatsapp: "+62 821-4113-7787",
    whatsappLink: "https://wa.me/6282141137787",
    whatsappMessage: "Hello, I'm interested in your coconut charcoal briquettes. Please provide more information.",
    location: "Sidoarjo, East Java, Indonesia",
  },
  seo: {
    title: "Samudra Charcoal | Premium Coconut Shell Charcoal Briquettes Manufacturer Indonesia",
    description: "Factory-direct coconut shell charcoal briquettes for shisha/hookah. Established 2016, export-ready, private label available. Max 2.5% ash content.",
    keywords: [
      "coconut shell charcoal briquette",
      "shisha charcoal briquettes manufacturer",
      "hookah charcoal cube 25mm",
      "private label shisha charcoal",
      "Indonesia coconut charcoal factory",
    ],
  },
  product: {
    name: "Coconut Shell Charcoal Briquette",
    specPdf: "https://customer-assets.emergentagent.com/job_hookah-source/artifacts/6t1v2w0e_A.1459%20COA%20CV.%20SAMUDRA%20KIAT%20JAYA.pdf",
    specs: {
      material: "100% Coconut Shell",
      shape: "Cube",
      size: "25mm x 25mm x 25mm",
      application: "Shisha / Hookah",
      ashContent: "Max 2.5%",
      moisture: "Max 5%",
      fixedCarbon: "Min 80%",
      burnTime: "45-60 minutes (approx.)",
      calorificValue: "7000-7500 kcal/kg",
    },
    benefits: [
      "Stable and consistent quality",
      "Long-lasting burn time",
      "Low ash content for best experience for shisha",
      "Minimal odor during use",
      "Made from 100% coconut shell charcoal from Sulawesi, Indonesia",
    ],
    packaging: {
      innerBox: ["Custom sizes available", "Your branding design"],
      masterCarton: ["10kg", "20kg", "Custom configurations"],
    },
  },
  trustHighlights: [
    { icon: "Sparkles", label: "Max 2.5% Ash" },
    { icon: "Package", label: "Private Label" },
    { icon: "ShieldCheck", label: "Lab Tested" },
    { icon: "Globe", label: "Export Worldwide" },
  ],
  processSteps: [
    { step: 1, title: "Raw Material Selection", description: "Premium coconut shell charcoal sourced from Sulawesi" },
    { step: 2, title: "Briquetting", description: "High-pressure molding into precise cube shapes" },
    { step: 3, title: "Drying", description: "Careful drying to achieve target moisture levels" },
    { step: 4, title: "Quality Control", description: "Rigorous testing for ash, moisture, and burn performance" },
    { step: 5, title: "Packing", description: "Professional packaging with customization options" },
  ],
  faq: [
    {
      question: "What is your Minimum Order Quantity (MOQ)?",
      answer: "Our standard MOQ is one 20ft container (approximately 18-20 tons).",
    },
    {
      question: "What is the typical lead time?",
      answer: "Production lead time is approximately 45 days. Shipping time varies by destination, typically around 2 months to most international ports.",
    },
    {
      question: "Do you provide samples?",
      answer: "Yes, we provide product samples. Sample costs and shipping are usually borne by the buyer. Sample costs can be deducted from your first bulk order.",
    },
    {
      question: "Do you offer private label/OEM services?",
      answer: "Absolutely. We offer complete private label services including custom box design, your branding, different languages, barcodes, and labeling per your requirements.",
    },
    {
      question: "What are your payment terms?",
      answer: "We work with T/T payment: 50% deposit upon order confirmation, and 50% before draft B/L (Bill of Lading).",
    },
    {
      question: "What shipping terms do you offer?",
      answer: "We offer FOB (Free On Board) terms only. Shipping prices fluctuate frequently, so buyers arrange their own freight forwarding from Indonesian port.",
    },
  ],
  about: {
    story: "Samudra Charcoal (CV. Samudra Kiat Jaya) has been manufacturing export-grade coconut shell charcoal briquettes since 2016. Based in Indonesia, we source premium coconut shell charcoal from Sulawesi and process it into high-quality briquettes for the global shisha market.",
    values: [
      { title: "Consistency", description: "Every batch meets our strict quality standards" },
      { title: "Reliability", description: "On-time delivery and clear communication" },
      { title: "Transparency", description: "Honest specifications and open factory audits" },
      { title: "Partnership", description: "Building long-term relationships with our clients" },
    ],
  },
  qcChecklist: [
    { item: "Moisture Content Test", description: "Verified ≤ 5%" },
    { item: "Ash Content Test", description: "Verified ≤ 2.5%" },
    { item: "Burn Performance Test", description: "Heat output and duration checked" },
    { item: "Physical Inspection", description: "Size, shape, and surface quality" },
    { item: "Packaging Inspection", description: "Box integrity and labeling accuracy" },
  ],
  privateLabelWorkflow: [
    { step: 1, title: "Consultation", description: "Tell us your packaging preferences and volume requirements" },
    { step: 2, title: "Artwork Submission", description: "Send your logo and design files for packaging" },
    { step: 3, title: "Mockup Approval", description: "We create digital mockups for your approval" },
    { step: 4, title: "Production & QC", description: "Manufacturing with your branding and quality checks" },
    { step: 5, title: "Shipping", description: "FOB delivery to Indonesian port" },
  ],
  privateLabelFeatures: [
    "Use your own brand name and logo",
    "Custom box design with your artwork",
    "Multiple language options (English, Arabic, etc.)",
    "Barcode and product labeling per your specs",
    "Custom order sizes accepted",
    "Master carton configurations",
  ],
  logistics: {
    shipping: {
      title: "FOB Shipping",
      description: "We offer FOB (Free On Board) terms from Indonesian port. Buyers arrange their own freight forwarding for best shipping rates.",
    },
    container: {
      title: "Container Loading",
      description: "Efficient container loading for 20ft containers. Each container holds approximately 18-20 tons of product.",
    },
    documentation: {
      title: "Documentation",
      description: "Commercial Invoice, Packing List, and export documentation support for smooth customs clearance.",
    },
  },
};

export const images = {
  logo: "/samudra-logo.png",
  hero: "https://customer-assets.emergentagent.com/job_shisha-briquettes/artifacts/ui9teb9v_PHOTO-2026-02-11-16-43-15.jpg",
  productCube: "https://customer-assets.emergentagent.com/job_shisha-briquettes/artifacts/ui9teb9v_PHOTO-2026-02-11-16-43-15.jpg",
  companyVideo: "https://customer-assets.emergentagent.com/job_shisha-briquettes/artifacts/p5i4iwiu_WhatsApp%20Video%202026-02-18%20at%2012.39.32.mp4",
  logistics: "https://images.pexels.com/photos/29899416/pexels-photo-29899416.jpeg?auto=compress&cs=tinysrgb&w=800",
  charcoalGlow: "https://customer-assets.emergentagent.com/job_shisha-briquettes/artifacts/ui9teb9v_PHOTO-2026-02-11-16-43-15.jpg",
  hookah: "/images/hookah-charcoal.jpg",
  carsurinCertificate: "https://customer-assets.emergentagent.com/job_hookah-source/artifacts/paxdb27v_PHOTO-2025-07-22-21-20-18.jpg",
};
